// @flow

import * as React from "react";
import { useSelector } from "react-redux";

import Modal from "../organisms/Modal";
import RichTextContent from "../molecules/RichTextContent";

type PropsType = {
    active?: boolean,
    onClose?: Function,
};

const SizeChartModal = (props: PropsType): React.Node => {
    const { size_chart } = useSelector((state: any): any => state.options);

    return (
        <>
            <Modal
                active={props.active}
                onClose={() => {
                    if (props.onClose) {
                        props.onClose();
                    }
                }}
            >
                <Modal.Header>Size Chart</Modal.Header>
                <Modal.Content>
                    <div className="container-fluid">
                        <RichTextContent html={size_chart} />
                    </div>
                </Modal.Content>
            </Modal>
        </>
    );
};

export default SizeChartModal;
